import React, { useState, useEffect } from 'react';
import { Checkbox, FormControlLabel, Grid, TextField } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { getUserPreference, setAutoLatLngPref } from '../../../utilities/common';
import { EditOutlined } from '@material-ui/icons';

export default function DestinationEditForm(props){
    const {trackingInfo, order, onInputChange, simplified, addressDisable} = props;

    const {t} = useTranslation('editOrder');
    const [autoLatLngChecked, setAutoLatLngChecked]= useState(true);
    const [editObject, setEditObject] = useState({});

    useEffect(() => {
        setEditObject({})
        setAutoLatLngChecked(getUserPreference().autoLatLng)
    }, [])

    return (
        <form>
            <Grid container spacing={2}>
                {!simplified ? 
                    <>
                        <Grid item xs={8}>
                            <TextField 
                                label={t('consignee')}
                                variant='outlined'
                                fullWidth
                                disabled
                                defaultValue={order.consignee}
                                onBlur={(e)=>handleInput('consignee', e.target.value, order.consignee)}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField 
                                label={t('phone')}
                                variant='outlined'
                                fullWidth
                                defaultValue={order.mobile}
                                onBlur={(e)=>handleInput('mobile', e.target.value, order.mobile)}
                            />
                        </Grid>
                    </>
                    :
                    null
                }
                {   !addressDisable &&
                    <>
                        <Grid item xs={3}>
                            <TextField 
                                label={t('unit')}
                                variant='outlined'
                                fullWidth
                                defaultValue={order.sign_building}
                                onBlur={(e)=>handleInput('sign_building', e.target.value, order.sign_building)}
                            />
                        </Grid>
                        <Grid item xs={9}>
                            <TextField 
                                label={t('address')}
                                variant='outlined'
                                fullWidth
                                defaultValue={order.address}
                                onBlur={(e)=>handleInput('address', e.target.value, order.address)}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField 
                                label={t('post_code')}
                                variant='outlined'
                                fullWidth
                                defaultValue={order.zipcode}
                                onBlur={(e)=>handleInput('zipcode', e.target.value, order.zipcode)}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField 
                                label={t('buzz_code')}
                                variant='outlined'
                                fullWidth
                                defaultValue={order.buzz_code}
                                onBlur={(e)=>handleInput('buzz_code', e.target.value, order.buzz_code)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox 
                                        color='primary'
                                        checked={autoLatLngChecked}
                                        onChange={(e)=>{
                                            setAutoLatLngPref(e.target.checked) 
                                            setAutoLatLngChecked(e.target.checked)
                                        }}
                                    />
                                }
                                label={t('auto_lng_lat')}
                            />
                        </Grid>
                    </>
                }
                {
                    (!autoLatLngChecked && !addressDisable) ?
                    <>
                        <Grid item xs={4}>
                            <TextField 
                                label={t('latitude')}
                                variant='outlined'
                                fullWidth
                                defaultValue={order.lat}
                                onBlur={(e)=>handleInput('lat', e.target.value, order.lat)}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField 
                                label={t('longitude')}
                                variant='outlined'
                                fullWidth
                                defaultValue={order.lng}
                                onBlur={(e)=>handleInput('lng', e.target.value, order.lng)}
                            />
                        </Grid>
                    </>
                    :
                    null
                }
            </Grid>
        </form>
    )

    function handleInput(key, value, compareTo){
        let trimmed = value.trim()
        if(value === compareTo || trimmed === compareTo)
            return
        let object = {
            ...editObject,
            [key]: trimmed
        }
        setEditObject(object)
        onInputChange(object)
    }
}

DestinationEditForm.defaultProps = {
    trackingInfo:{},
    order:{},
    simplified: false,
    addressDisable: false
}